import { queryOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "./query-keys";
import { fetchMedia, fetchMediaByProduct, deleteAllProductMedia } from "../api/media";

export type { Media } from "../api/media/types";

// Query options for user's media
export const mediaQueryOptions = (userId: string) =>
  queryOptions({
    queryKey: queryKeys.media.userList(userId),
    queryFn: () => fetchMedia(userId),
    enabled: !!userId,
  });

// Query options for product's media
export const mediaByProductQueryOptions = (productId: string, userId?: string) =>
  queryOptions({
    queryKey: queryKeys.media.productList(productId),
    queryFn: () => fetchMediaByProduct(productId, userId),
    enabled: !!productId,
  });

// Delete all product media mutation
export const useDeleteProductMediaMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ productId, userId }: { productId: string; userId?: string }) =>
      deleteAllProductMedia(productId, userId),
    onSuccess: (_data, { productId }) => {
      // Invalidate product media cache
      queryClient.invalidateQueries({
        queryKey: queryKeys.media.productList(productId),
      });
    },
  });
};
